import { useState, useEffect } from "react";
import { validate, getCardType } from "utils";
import Input from "@/components/elements/Input/Input";

const CreditCardInput = ({value, onChange, disabled, testId="CreditCardInput", theme="white"}) => {

    const [cardType, setCardType] = useState("")

    useEffect(()=>{
        if(typeof value === 'string' || typeof value === "number"){
            setCardType(getCardType(value.toString()))
        }
    }, [value])

    return (
        <Input
            type="text"
            theme={theme}
            placeholder="Credit card number"
            autoFocus={true}
            value={value}
            name="cardNumber"
            autoComplete="cc-number"
            onChange={onChange}
            disabled={disabled}
            testId={testId}
            maxLength={19}
            valid={validate.cardNumber(value, cardType).valid}
            id="cardNumber"
        />
     );
}

export default CreditCardInput;
